<template>
  <div class="index">
    <div class="banner">
      <img src="../assets/banner.png" />
    </div>
    <Back />
    <div class="tab">
      <p
        v-for="(item, index) in tabList"
        :key="index"
        :class="value1 == index ? 'active' : ''"
        @click="value1 = index"
      >
        {{ item }}
      </p>
    </div>

    <transition enter-active-class="animated zoomIn">
      <div class="function" v-if="value1 == 0">
        <video-player
          style="width: 100%"
          class="video-player vjs-custom-skin video"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions1"
        ></video-player>
      </div>

      <div class="function" v-if="value1 == 1">
        <video-player
          style="width: 100%"
          class="video-player vjs-custom-skin video"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions2"
        ></video-player>
      </div>

      <div class="function" v-if="value1 == 2">
        <video-player
          style="width: 100%"
          class="video-player vjs-custom-skin video"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions3"
        ></video-player>
      </div>

      <div class="function" v-if="value1 == 3">
        <video-player
          style="width: 100%"
          class="video-player vjs-custom-skin video"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions4"
        ></video-player>
      </div>
    </transition>
  </div>
</template>

<script>
import Back from "../components/back.vue";
export default {
  data() {
    return {
      value1: 0,

      tabList: ["漫游一", "漫游二", "漫游三", "漫游四"],

      playerOptions1: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //倍速控制
        autoplay: true, //是否自动播放
        muted: false, //是否静音播放
        loop: false, //是否循环播放
        preload: "auto",
        language: "zh-CN", //语言，还要引入对应的文件
        aspectRatio: "16:9", //比例
        fluid: true,
        sources: [
          {
            type: "",
            src: require("../assets/roam1.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true, //剩余时间是否显示
          remainingTimeDisplay: false, //剩余时间是否显示，有一个即可
          fullscreenToggle: true, //全屏按钮
        },
      },
      playerOptions2: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //倍速控制
        autoplay: true, //是否自动播放
        muted: false, //是否静音播放
        loop: false, //是否循环播放
        preload: "auto",
        language: "zh-CN", //语言，还要引入对应的文件
        aspectRatio: "16:9", //比例
        fluid: true,
        sources: [
          {
            type: "",
            src: require("../assets/roam2.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true, //剩余时间是否显示
          remainingTimeDisplay: false, //剩余时间是否显示，有一个即可
          fullscreenToggle: true, //全屏按钮
        },
      },
      playerOptions3: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //倍速控制
        autoplay: true, //是否自动播放
        muted: false, //是否静音播放
        loop: false, //是否循环播放
        preload: "auto",
        language: "zh-CN", //语言，还要引入对应的文件
        aspectRatio: "16:9", //比例
        fluid: true,
        sources: [
          {
            type: "",
            src: require("../assets/roam3.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true, //剩余时间是否显示
          remainingTimeDisplay: false, //剩余时间是否显示，有一个即可
          fullscreenToggle: true, //全屏按钮
        },
      },
      playerOptions4: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //倍速控制
        autoplay: true, //是否自动播放
        muted: false, //是否静音播放
        loop: false, //是否循环播放
        preload: "auto",
        language: "zh-CN", //语言，还要引入对应的文件
        aspectRatio: "16:9", //比例
        fluid: true,
        sources: [
          {
            type: "",
            src: require("../assets/roam4.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true, //剩余时间是否显示
          remainingTimeDisplay: false, //剩余时间是否显示，有一个即可
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  components: {
    Back,
  },

  methods: {
    // to(e) {
    //   this.value1 = e;
    //   this.playerOptions.sources.src = this.vList[this.value1];
    // },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.function {
  width: 320px;
  height: 215px;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  background: #fff;
  margin: auto;
}
.tab {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 200px;
  p {
    font-size: 16px;
    color: #666;
    line-height: 35px;
    margin: 20px;
  }
  .active {
    color: #ffbc1e;
    position: relative;
    border-bottom: 2px solid #ffbc1e;
  }
}
.index {
  width: 100%;
  height: 100%;
  text-align: center;
  overflow: hidden;
  .list {
    width: 100%;
    height: 65px;
    display: flex;
    justify-content: center;
    background: #fff;
    bottom: 0;
    position: fixed;
    align-items: center;
  }
  .box {
    p {
      font-size: 10px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      line-height: 18px;
      color: #999;
      margin: 0 20px;
    }
    .active {
      color: #ffbc1e;
    }
  }
}

.banner {
  width: 100%;
  height: 200px;
  position: fixed;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
